<template>
<b-row>
    <b-colxx xxs="12">
        <b-card class="mb-4">
            <div>
                <b-row align-v="center" class="justify-content-start" no-gutters>
                    <b-col>
                        <h5 class="mb-2 mt-3">판매채널</h5>
                    </b-col>
                </b-row>
                <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
                    <b-col md="12">
                        <b-form>
                            <b-form-group>
                                <b-form-radio-group v-model="_agreementExternalChannelDist" :disabled="isModifyMode != false" :options="[
                { value: true , text: '외부채널 배포 동의'},
                { value: false , text: '동의 안함' } ]"></b-form-radio-group>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
                    <b-col v-if="_agreementExternalChannelDist" md="12">
                        <table class="table table-bordered">
                            <tr>
                                <td>
                                    다음 중 배포를 원하는 채널을 선택해주세요.
                                    <!--                    ({{_channelCodes.length}}개 선택 됨)-->
                                    <br>
                                    <span style="color:red">* 신규채널 추가 오픈시 해당 채널 배포는 동의한 것으로 간주됩니다.</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b-form-group>
                                        <b-form-checkbox-group :disabled="this.isModifyMode != false" id="btn-radios-3" v-model="_channelCodes" :options="channelCodesOptions" button-variant="outline-primary default" size="sm" name="radio-btn-outline" disabled-field="notEnabled" />
                                    </b-form-group>
                                </td>
                            </tr>
                        </table>
                    </b-col>
                    <b-col md="12">
                        <table class="table table-bordered">
                            <tr>
                                <td>테이블엔조이 배포여부</td>
                            </tr>
                            <tr>
                                <td>
                                    <b-form-radio-group v-model="_tablenjoyExcluded" :disabled="this.isModifyMode != false">
                                        <b-form-radio :value="false">테이블엔조이 배포 동의</b-form-radio>
                                        <b-form-radio :value="true">테이블엔조이 배포 동의 안함</b-form-radio>
                                    </b-form-radio-group>
                                </td>
                            </tr>
                        </table>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </b-colxx>
</b-row>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";

export default {
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            isModifyMode: false,
            isReqModifyMode: false,
            goodsParamsId: null, //등록된 상품아이디
            registerId: null, //등록대기 상품아이디
            copyRegisterId: null,
        }
    },
    watch: {
        _channelCodes(val) {
            // console.log("_channelCodes",val);
        },

    },
    computed: {
        ...mapGetters([
            'currentUser',
            'siteName',
            'goodsType',
            'agreementExternalChannelDist',
            'channelCodes',
            'tablenjoyExcluded',
            'channelCodesOptions',
        ]),

        _agreementExternalChannelDist: {
            get: function () {
                return this.agreementExternalChannelDist
            },
            set: function (e) {
                this.setAgreementExternalChannelDist(e)
            }
        },

        _channelCodesOptions: {
            get: function () {
                return this.channelCodesOptions
            }
        },

        _tablenjoyExcluded: {
            get: function () {
                return this.tablenjoyExcluded
            },
            set: function (e) {
                this.setTablenjoyExcluded(e)
            }
        },

        _channelCodes: {
            get: function () {
                return this.channelCodes
            },
            set: function (e) {
                this.setChannelCodes(e)
            }
        },

    },
    mounted() {

        //신규상품
        this.registerId = this.$route.params.registerId !== undefined ? this.$route.params.registerId : null
        if (this.registerId !== null) {
            this.isReqModifyMode = true
        }

        //등록상품
        this.goodsParamsId = this.$route.params.goodsId !== undefined ? this.$route.params.goodsId : null
        if (this.goodsParamsId !== null) {
            this.isModifyMode = true
        }
        //판매채널 조회
        if (!this.isReqModifyMode && !this.isModifyMode) {
            this.goodsChannelCodesOptions({
                currentUser: this.currentUser,
                siteName: this.siteName,
                modeFlag: false
            })
        }

    },

    methods: {

        ...mapMutations(['setAgreementExternalChannelDist', 'setChannelCodes', 'setTablenjoyExcluded']),
        ...mapActions(['goodsChannelCodesOptions']),

    }
}
</script>
